import * as React from 'react';
import { Layers } from 'lucide-react';
import type { Territory } from '@hetivo/hetivo-lib-types';
import { cn } from '@hetivo/hetivo-lib-web-utils';
import { useTranslation } from 'react-i18next';
import { useMasterContext } from '&/master';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface TerritoryResultProps {
  onClose: () => void;
  territory: Territory;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function TerritoryResult({ onClose, territory }: TerritoryResultProps): React.JSX.Element {
  const { t } = useTranslation('common');
  const { selectTerritory, territoryId: currentTerritoryId } = useMasterContext();
  const isActive = territory.id === currentTerritoryId;

  const handleSelect = (): void => {
    selectTerritory(territory.id);
    onClose();
  };

  return (
    <button
      className={cn(
        'flex items-center gap-2 px-2.5 py-2 mx-1 w-[calc(100%-0.5rem)] rounded-md transition-colors text-left group/territory-result',
        isActive ? 'bg-accent' : 'hover:bg-muted',
      )}
      onClick={handleSelect}
      type="button"
    >
      <Layers className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
      <span className="flex-1 text-xs truncate">{territory.name}</span>
      {isActive ? (
        <span className="text-[9px] font-semibold text-muted-foreground bg-muted px-1.5 py-0.5 rounded shrink-0">
          {t('mainSelector.current')}
        </span>
      ) : (
        <span className="text-[11px] text-primary font-medium hidden group-hover/territory-result:inline shrink-0">
          {t('mainSelector.select')}
        </span>
      )}
    </button>
  );
}
